import { useEffect, useContext } from 'react';
import { useLocation } from '@reach/router';
import { useBreadcrumb } from 'gatsby-plugin-breadcrumb';

import { BreadcrumbContext } from '../contexts/breadcrumb';
import { usePaths } from './usePaths';
import { useLanguage } from './useLanguage';
import { getArrayWithoutDuplicate } from '../utils/getters';

export const useCustomBreadcrumb = () => {
  const location = useLocation();
  const { langKey } = useLanguage();
  const { customCrumbs, setCustomCrumbs } = useContext(BreadcrumbContext);

  const {
    getPathsWithContentfulId,
    getPathObjectWithPathname,
    getPathWithLanguageKey
  } = usePaths();
  const { crumbs } = useBreadcrumb({
    location
  });

  useEffect(() => {
    const updatedCrumbs = crumbs.map((c) => {
      const crumbPathsContentfulId = getPathObjectWithPathname(
        c.pathname
      )?.contentful_id;
      const crumbPaths = getPathsWithContentfulId(crumbPathsContentfulId);
      const pathname = getPathWithLanguageKey(crumbPaths)?.gatsbyPath;
      return {
        ...c,
        pathname
      };
    });

    setCustomCrumbs(getArrayWithoutDuplicate(updatedCrumbs, 'pathname'));
  }, [crumbs, langKey]);

  return {
    customCrumbs
  };
};
